import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../App.css";

export const Navigation = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [demoCloseTimeout, setDemoCloseTimeout] = useState(null);

  // Load dark mode preference from localStorage
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedMode);
    document.body.classList.toggle("dark-mode", savedMode);
  }, []);

  // Handle scroll event to change navbar appearance
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? "auto" : "hidden";
  };

  // Close menu when clicking on a link
  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  // Toggle demo dropdown
  const toggleDemo = () => {
    setIsDemoOpen(!isDemoOpen);
  };

  // Handle mouse enter/leave for demo dropdown with delay
  const handleDemoMouseEnter = () => {
    if (demoCloseTimeout) {
      clearTimeout(demoCloseTimeout);
      setDemoCloseTimeout(null);
    }
    setIsDemoOpen(true);
  };

  const handleDemoMouseLeave = () => {
    const timeout = setTimeout(() => {
      setIsDemoOpen(false);
    }, 200); // 200ms delay
    setDemoCloseTimeout(timeout);
  };

  // Close demo dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.nav-item.dropdown')) {
        setIsDemoOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Toggle dark mode and save preference
  const handleDarkModeToggle = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    document.body.classList.toggle("dark-mode", newMode);
    localStorage.setItem("darkMode", newMode);
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMenu}>
            <img src={darkMode ? "/img/logo_dark.png" : "/img/logo.png"} alt="Nexagen Logo" />
          </Link>

          <button
            className={`hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>

          <ul className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
            <li className="nav-item">
              <a href="#features" className="nav-link" onClick={closeMenu}>
                Offer
              </a>
            </li>
            <li className="nav-item">
              <a href="#about" className="nav-link" onClick={closeMenu}>
                About
              </a>
            </li>
            <li className="nav-item">
              <a href="#services" className="nav-link" onClick={closeMenu}>
                Products
              </a>
            </li>
            <li
              className={`nav-item dropdown ${isDemoOpen ? "active" : ""}`}
              onMouseEnter={handleDemoMouseEnter}
              onMouseLeave={handleDemoMouseLeave}
            >
              <button
                className="nav-link dropdown-toggle"
                style={{ padding: "12px 24px" }}
                onClick={toggleDemo}
                aria-expanded={isDemoOpen}
              >
                Demo <span className="dropdown-arrow">▼</span>
              </button>
              <ul className={`dropdown-menu ${isDemoOpen ? "show" : ""}`} style={{ minWidth: "220px", paddingTop: "8px", paddingBottom: "8px" }}>
                <li>
                  <Link to="/demo/hr-management" className="dropdown-item" onClick={closeMenu}>
                    <div className="dropdown-item-content">
                      <div className="dropdown-item-icon">
                        <i className="fa fa-users"></i>
                      </div>
                      <div className="dropdown-item-text">
                        <div className="dropdown-item-title">HR Management Portal</div>
                        <div className="dropdown-item-description">Employee management & payroll system</div>
                      </div>
                      <div className="dropdown-item-badge">Popular</div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/demo/travel-agency" className="dropdown-item" onClick={closeMenu}>
                    <div className="dropdown-item-content">
                      <div className="dropdown-item-icon">
                        <i className="fa fa-plane"></i>
                      </div>
                      <div className="dropdown-item-text">
                        <div className="dropdown-item-title">Travel Agency Accounting</div>
                        <div className="dropdown-item-description">Tour booking & financial management</div>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/demo/inventory-management" className="dropdown-item" onClick={closeMenu}>
                    <div className="dropdown-item-content">
                      <div className="dropdown-item-icon">
                        <i className="fa fa-archive"></i>
                      </div>
                      <div className="dropdown-item-text">
                        <div className="dropdown-item-title">Inventory Management</div>
                        <div className="dropdown-item-description">Stock control & warehouse operations</div>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/demo/ecommerce" className="dropdown-item" onClick={closeMenu}>
                    <div className="dropdown-item-content">
                      <div className="dropdown-item-icon">
                        <i className="fa fa-shopping-cart"></i>
                      </div>
                      <div className="dropdown-item-text">
                        <div className="dropdown-item-title">E-commerce Software</div>
                        <div className="dropdown-item-description">Online store & marketplace integration</div>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/demo/general-accounting" className="dropdown-item" onClick={closeMenu}>
                    <div className="dropdown-item-content">
                      <div className="dropdown-item-icon">
                        <i className="fa fa-calculator"></i>
                      </div>
                      <div className="dropdown-item-text">
                        <div className="dropdown-item-title">General Accounting</div>
                        <div className="dropdown-item-description">Complete financial management suite</div>
                      </div>
                    </div>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a href="#team" className="nav-link" onClick={closeMenu}>
                Team
              </a>
            </li>
            <li className="nav-item">
              <a href="#testimonials" className="nav-link" onClick={closeMenu}>
                Testimonials
              </a>
            </li>
            <li className="nav-item">
              <Link to="/blogs" className="nav-link" onClick={closeMenu}>
                Blogs
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={closeMenu}>
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/register"
                className="register-btn"
                onClick={closeMenu}
              >
                Register Now <span className="register-plus">+</span>
              </Link>
            </li>

            {/* 🌙 Dark Mode Toggle */}
            <li className="nav-item theme-toggle-mobile">
              <div className="theme-toggle" onClick={handleDarkModeToggle} title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}>
                <div className={`theme-toggle-track ${darkMode ? "dark" : "light"}`}>
                  <div className="theme-toggle-icon sun-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>
                    </svg>
                  </div>
                  <div className="theme-toggle-icon moon-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/>
                    </svg>
                  </div>
                  <div className={`theme-toggle-thumb ${darkMode ? "dark" : "light"}`}></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      {/* Mobile menu overlay */}
      <div
        className={`mobile-menu-overlay ${isMenuOpen ? "active" : ""}`}
        onClick={closeMenu}
      ></div>
    </>
  );
};
